<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="ProductionCapacityExportTable" :fields="fields" :title="table_title.title1"
        :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :isBusy="isBusy_table" :query_button_label="query_lable" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 1]" @tool_invoke="tool_invoke" @current_changed="current_changed">
        <template #toolbar="">
          <div style="display: inline-block">
            <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" accept=".xlsx"
              :on-exceed="exceed" :limit="1" :on-remove="remove" :http-request="uploadFile"
              :before-upload="beforeFileUpload" :show-file-list="false" :file-list="fileList" :on-success="successFile">
              <el-button plain type="info" style="width: 55px" class="ml-2"><i
                  class="iconfont icon-export-in"></i></el-button>
              <!-- <div slot="tip" class="el-upload__tip">1次只能上传1个xls文件</div> -->
            </el-upload>
          </div>
          <!-- <a href="" class="ml-2 mb-0">模板下载</a> -->
          <el-tooltip content="模板下载" placement="top" effect="light">
            <el-button plain type="info" style="width: 55px" @click="downloadTemplate" class="ml-2"><i
                class="iconfont icon-template"></i>
            </el-button>
          </el-tooltip>
        </template>
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveExport"
            :label="$t('common.save')" class="ml-2">
          </QueryButton>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import XLSX from "xlsx"
import * as ProductionCapacityController from "../../controllers/fi/ProductionCapacityController"
import * as api from "../../shared/api"
import * as base_url from "../../shared/base_url"
import * as localStorageMgr from "../../shared/localStorageMgr"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import TableMain from "../components/table/TableMain"
export default {
  name: "ProductionCapacityExport",
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
  },
  props: {
    is_pub: { type: Boolean, default: () => false },
  },
  data() {
    return {
      guest_info: null,
      fileList: [],
      table_title: {
        title1: "table_production_capacity_import",
      },
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      fields: ProductionCapacityController.fields.export_field,
      dataList: [],
      isBusy_table: false,
      base_url: base_url.base_url,
    }
  },
  created() {
    if (localStorageMgr.data.guest_info && this.ls.get(localStorageMgr.data.guest_info))
      this.guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
  },
  methods: {
    downloadTemplate() {
      window.location.href =
        this.base_url + "/excel_template/" + "产能管理导入模板20240802.xlsx"
    },
    current_changed(old, current) { },
    tool_invoke(data) { },
    state_change(data, cb) {
      if (data.state === "deleted") {
        this.$refs.ProductionCapacityExportTable.RemoveItems(
          data.selected_items
        )
      }
    },
    //上传1个以上文件时弹窗提示错误
    exceed: function () {
      // this.$message.error("最多只能上传1个xls文件");
      this.msgToasts("最多只能上传1个xls文件!", "info")
    },
    //删除
    remove() { },
    successFile() {
      //this.isBusy_table3 = false
    },
    async uploadFile(params) {
      this.isBusy_table = true
      this.$refs.ProductionCapacityExportTable.SetData([])
      let _this = this
      let _file = params.file
      let fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          let data = ev.target.result
          let workbook = XLSX.read(data, {
            type: "binary",
            cellDates: true,
          })
          let listTable = []

          let _keys_sheets = _.keys(workbook.Sheets)
          let sheet = workbook.Sheets[_keys_sheets[0]]
          let sheetArray = XLSX.utils.sheet_to_json(sheet, { defval: "" })
          if (sheetArray.length == 0) {
            this.msgToasts(this.$t("notify.not_data"), "error")
            return
          }
          ///检查模板是否正确
          let _sheet_keys = _.keysIn(sheetArray[0])
          let _fields_keys = _.keysIn(_.keyBy(this.fields, "label"))
          _.remove(_fields_keys, (n) => {
            return n == this.$t("common.provider") + this.$t("common.name")
          })
          let dif = _.difference(_fields_keys, _sheet_keys)
          if (dif.length > 0) {
            this.msgToasts(this.$t("notify.template_error"), "error")
            return
          }

          // console.log(sheetArray)
          _.each(sheetArray, (t) => {
            let _p = {}
            _.forIn(_.keyBy(this.fields, "label"), (v, k) => {
              if (_.isDate(t[k])) {
                _p[v.key] = _this.$date.format(
                  _this.$date.addDays(t[k], 1),
                  "yyyy-MM-dd"
                )
              } else {
                _p[v.key] = t[k]
              }
            })
            listTable.push(_p)
          })

          _.each(listTable, (t) => {
            let _m = _.find(_this.$store.state.biz_data.baseData.Vender, {
              AccountNum: _.toString(t.AccountNum),
            })
            if (_m) {
              t.SEI_Name = _m.SEI_Name
            }
          })
          console.log(listTable.reverse())
          _this.$refs.ProductionCapacityExportTable.SetData(
            listTable.reverse()
          )
        } catch (e) {
          this.msgToasts(this.$t("notify.file_type_error"), "info")

          this.isBusy_table = false
        }
      }
      fileReader.readAsBinaryString(_file)
      this.isBusy_table = false
      this.fileList = []
    },
    //before上传
    beforeFileUpload() { },
    ErrorMsg(data) {
      if (_.isNull(data.ProductionCapacity)) {
        return ("<div>" + this.$t("common.provider") + ":<strong>" + data.AccountNum + "</strong>，<strong>" + this.$t("common.capacity") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.AccountNum)) {
        return ("<div>" + this.$t("common.provider") + ":<strong>" + data.AccountNum + "</strong>，<strong>" + this.$t("common.provider") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.SEI_Name)) {
        return ("<div>" + this.$t("common.provider") + ":<strong>" + data.AccountNum + "</strong>，<strong>" + this.$t("common.provider") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      return ""
    },
    //保存
    async saveExport(cb) {
      let _this = this
      if (this.$refs.ProductionCapacityExportTable.my_data.length == 0) {
        cb(false)
        return
      }

      let _is_ok = true
      let _data = _.cloneDeep(this.$refs.ProductionCapacityExportTable.my_data)

      if (_is_ok) {
        this.msgModal(this.$t("notify.is_continue")).then(async (value) => {
          if (value) {
            ///整理数据
            let _list = []
            let _batch_date = this.$date.format(
              new Date(),
              "yyyy-MM-dd HH:mm:ss"
            )
            _.each(_data, (t) => {
              t.batch_date = _batch_date
              let _mt = {
                id: "",
                AccountNum: t.AccountNum,
                SEI_Name: t.SEI_Name,
                ProductionCapacity: t.ProductionCapacity,
                set_date: t.set_date,
                description: t.description,
                batch_date: _batch_date,
              }
              _list.push(_mt)
            })
            let data = {}
            data.username = this.$global.global_data.local_username
            data.data = _list
            let result = null
            let result1 = null
            if (this.is_pub) {
              let _p = new FormData()
              _p.append("json", JSON.stringify(data))

              result1 = await api.query_async({
                url: api.pub_url("save", this.guest_info.idx, "generate_ProductionCapacity"),
                parameters: _p,
                method: "post",
              })
              if (
                result1 &&
                result1[0].result &&
                result1[0].result.data &&
                result1[0].result.data.Result &&
                result1[0].result.data.Result.length > 0
              ) {
                result = result1[0].result.data.Result
              }
            } else {
              result =
                await ProductionCapacityController.methods.SaveProductionCapacityExport(
                  JSON.stringify(data)
                )
            }

            if (result && result.length > 0) {
              //判断后台是否写入成功
              if (result[0][0].status == 0) {
                this.$refs.ProductionCapacityExportTable.SetData([])
                this.msgToasts(this.$t("notify.import_success"), "success")
                this.$refs.ProductionCapacityExportTable.SetData([])
                cb(true, true)
              } else {
                let str = "<div><strong>" + this.$t("notify.import_failed_error") + ":</strong></div>"
                _.each(result[0], (t) => {
                  if (
                    _.isNull(t.ProductionCapacity) ||
                    _.isNull(t.AccountNum) ||
                    _.isNull(t.SEI_Name)
                  ) {
                    console.log(t)
                    //标红错误行
                    let item = this.$refs.ProductionCapacityExportTable.my_data[parseInt(t._id)]
                    item._rowVariant = "danger"
                    item._selected = true
                    this.$set(this.$refs.ProductionCapacityExportTable.my_data, t._id, item)
                    str += this.ErrorMsg(t)
                  }
                })
                this.msgToasts(str, "error", 0, true, "notify550")
                cb(false)
                return
              }
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
              cb(false)
            }
          } else {
            cb(false)
          }
        })
      } else {
        cb(false)
      }
    },
  },
}
</script>
